const directive = {
  //滑动指令
  bind: function (el, binding, vnode) {
    var touchType = binding.arg; //传入的模式 press swipeRight swipeLeft swipeTop swipeDowm Tap
    var timeOutEvent = 0;
    var direction = '';
    //滑动处理
    var startX, startY;
    var startTime = '';
    var endTime = '';
    var moveTime = '';
    //返回角度
    function GetSlideAngle(dx, dy) {
      return Math.atan2(dy, dx) * 180 / Math.PI;
    }

    //根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
    function GetSlideDirection(spanX, spanY, moveTime) {
      var result = 0;

      //如果滑动距离太短
      if (Math.abs(spanX) < 30 && Math.abs(spanY) < 30) {
        return result;
      }
      var angle = GetSlideAngle(spanX, spanY);
      if (moveTime < 500) {
        if (Math.abs(spanX) > Math.abs(spanY)) {
          //认定为水平方向滑动
          if (spanX > 30 && angle >= -35 && angle <= 35) {
            //向右
            result = 'swiperight';
          } else if (spanX < -30 && angle >= 165 && angle <= 180 || angle >= -180 && angle < -165) {
            //向左
            result = 'swipeleft';
          }
        } else {
          //认定为垂直方向滑动
          if (spanY > 30) {
            //向下
            result = 'swipedown';
          } else if (spanY < -30) {
            //向上
            result = 'swipeup';
          }
        }
      }
      console.log(result, angle);
      return result;
    }
    el.addEventListener('touchstart', function (ev) {
      startTime = new Date().getTime();
      startX = ev.touches[0].pageX;
      startY = ev.touches[0].pageY;

      //判断长按
      timeOutEvent = setTimeout(() => {
        timeOutEvent = 0;
        if (touchType === 'press') {
          binding.value();
        }
      }, 800);
    }, false);
    el.addEventListener('touchmove', function (ev) {
      clearTimeout(timeOutEvent);
      timeOutEvent = 0;
    });
    el.addEventListener('touchend', function (ev) {
      endTime = new Date().getTime();
      moveTime = endTime - startTime;
      var endX, endY, spanX, spanY;
      endX = ev.changedTouches[0].pageX;
      endY = ev.changedTouches[0].pageY;
      spanX = endX - startX;
      spanY = endY - startY;
      direction = GetSlideDirection(spanX, spanY, moveTime);
      clearTimeout(timeOutEvent);
      switch (direction) {
        case 0:
          break;
        case 'swipeup':
          if (touchType === 'swipeup') {
            binding.value();
          }
          break;
        case 'swipedown':
          if (touchType === 'swipedown') {
            binding.value();
          }
          break;
        case 'swipeleft':
          if (touchType === 'swipeleft') {
            binding.value();
          }
          break;
        case 'swiperight':
          if (touchType === 'swiperight') {
            binding.value();
          }
          break;
        default:
      }
    }, false);
  }
};
export default directive;